export default "__VITE_ASSET__Vg6OrynH__"